import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const CheckPayout = props => <PayoutWorkspace mode="check" {...props} />;
export default CheckPayout;
